
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/survey-closed",
      function () {
        return require("private-next-pages/survey-closed/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/survey-closed"])
      });
    }
  